var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCriticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    viewBox: "0 0 8 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.96032 0.664929C3.49563 -0.221114 4.50969 -0.222776 5.04219 0.666741L5.05735 0.694081L7.79593 5.29196C8.32265 6.14386 7.77718 7.01027 6.76203 6.99819V7H1.14892C1.13486 7 1.12111 6.9994 1.10736 6.99834C0.1958 6.98641 -0.246386 6.17936 0.140175 5.38455C0.146269 5.37171 0.152988 5.35933 0.160175 5.34739L0.15955 5.34694L2.9611 0.665382L2.96032 0.664929ZM3.74657 5.2326C3.81313 5.17021 3.89266 5.1391 3.97235 5.13351C4.02547 5.12988 4.0786 5.13789 4.12766 5.15586C4.17657 5.17384 4.22157 5.20163 4.25875 5.23758C4.36688 5.34196 4.395 5.5001 4.33125 5.63272C4.28922 5.72033 4.22063 5.77924 4.14204 5.81065C4.09469 5.82984 4.0436 5.83845 3.99266 5.83724C3.94157 5.83603 3.89126 5.82485 3.84563 5.80431C3.76719 5.76912 3.70032 5.70719 3.66282 5.62003C3.62141 5.52397 3.62735 5.42428 3.67266 5.33078C3.69063 5.29362 3.71563 5.25812 3.74657 5.2326ZM4.27563 4.52162C4.26313 4.82235 3.73641 4.82265 3.72438 4.52147C3.6711 4.0064 3.53485 2.85194 3.53923 2.36784C3.5436 2.21875 3.67157 2.13039 3.83516 2.09671C3.88563 2.08628 3.9411 2.08115 3.99688 2.0813C4.05313 2.08145 4.10876 2.08674 4.15922 2.09716C4.32829 2.1319 4.46094 2.22389 4.46094 2.37584L4.46016 2.39095L4.27563 4.52162Z",
    fill: "#E04C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriticalIcon);
export default __webpack_public_path__ + "static/media/critical-icon.debc39412ab68bea80c168c2bb495602.svg";
export { ForwardRef as ReactComponent };